"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.states = void 0;

var _styledComponents = require("styled-components");
/**
 * Module dependencies.
 */

/**
 * Export states.
 */


var states = {
  action: function action(styles) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    return (0, _styledComponents.css)(["&,&:active,&:focus,&:hover,&:visited{", "}"], _styledComponents.css.apply(void 0, [styles].concat(interpolations)));
  },
  interaction: function interaction(styles) {
    for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    return (0, _styledComponents.css)(["&.active,&:active,&:focus,&:hover{", "}"], _styledComponents.css.apply(void 0, [styles].concat(interpolations)));
  }
};
exports.states = states;